import { useTranslation } from "react-i18next";
import { AffiliationTypesChooser } from "../AffiliationTypesChooser";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";
import { useSearchContext } from "../../contexts";

interface AffiliationTypesChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const AffiliationTypesChooserDropdown: React.FC<AffiliationTypesChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Affiliation Category")}
      counter={state.draftFilters.affiliationTypes.value.length}
      isExclude={state.draftFilters.affiliationTypes.exclude}
      onOpenChange={onOpenChange}
    >
      <AffiliationTypesChooser />
    </DropdownFilter>
  );
};
